import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19d7ee02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagebox" }
const _hoisted_2 = { class: "routerbox" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "统计", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "控制面板", -1))
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_van_tabbar, {
      route: "",
      "inactive-color": "#949CA1",
      "active-color": "#1D5A93",
      placeholder: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/app/environmentaltest/tongji"
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: 
              props.active
                ? require('@/assets/anquanjiancha/tongji-a.png')
                : require('@/assets/anquanjiancha/tongji.png')
            
            }, null, 8, _hoisted_4)
          ]),
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, { to: _ctx.skipRouter }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: 
              props.active
                ? require('@/assets/environmentaltest/pancel-a.png')
                : require('@/assets/environmentaltest/pancel.png')
            
            }, null, 8, _hoisted_6)
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    })
  ]))
}